import FilterSticky from "../typescript/modules/filter-controls-sticky";
import FilterSlideOut from "../typescript/modules/filter-slide-out";
import Filters from "../typescript/modules/filters";
import ListExpander from "../typescript/modules/list-expander";
import RevealContent from "../typescript/modules/reveal-content";
import SelectorFilter from "../typescript/modules/selector-filter";
import ShowMoreText from "../typescript/modules/show-more-text";
import SlideToggle from "../typescript/modules/slide-toggle";
import Slideshow from "../typescript/modules/slideshow";
import ToggleBlock from "../typescript/modules/toggle-block";

(<any>window).FilterSticky = FilterSticky;
new FilterSticky();

(<any>window).FilterSlideOut = FilterSlideOut;
new FilterSlideOut();

(<any>window).RevealContent = RevealContent;
new RevealContent();

(<any>window).ListExpander = ListExpander;

(<any>window).ToggleBlock = ToggleBlock;
new ToggleBlock();

(<any>window).Filters = Filters;
const filtersFormElement = document.getElementById('filters') as HTMLFormElement;
if (filtersFormElement) {
	new Filters(filtersFormElement);
}

(<any>window).slideToggle = new SlideToggle();

const showMoreTriggers = SelectorFilter.excludeByClass(document.querySelectorAll('.js-show-more-text'), 'js-show-more-text-done');
for (let i = 0; i < showMoreTriggers.length; i++) {
	new ShowMoreText(showMoreTriggers[i]);
}

const slideshows = document.querySelectorAll('.js-slideshow') as NodeListOf<HTMLElement>;

for (let i = 0; i < slideshows.length; i++) {
	new Slideshow(slideshows[i]);
}
